import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import fileDownload from 'js-file-download';

type Req = {
  adminUserId: string;
  candidateId: string;
};

type Response = void;

type Return = {
  downloadCandidateProcessCv: (req: Req) => Promise<Response>;
  isDownloading: boolean;
};

export const useDownloadCandidateProcessCv = (): Return => {
  const { adminCandidatesApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const response = await adminCandidatesApi.downloadCandidateProcessCv(
        req.adminUserId,
        req.candidateId,
        {
          responseType: 'blob',
        },
      );
      const fileName =
        response.headers['content-disposition'].match(/attachment; filename=(.*)/)[1] ??
        'processCv.pdf';
      fileDownload(response.data, fileName, 'application/pdf');
    },
  });

  return {
    downloadCandidateProcessCv: mutateAsync,
    isDownloading: isPending,
  };
};
